import React from 'react';
import cx from 'classnames';

export default function NotFound(props) {
    return (
        <div className={cx("NotFound", props.className)}>
            <h1>Sorry, can't find that.</h1>
        </div>
    )
}
